import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import { Card, CardBody, Col } from "reactstrap";
import { ImagePreviewTitle } from "../../../constants";
import { ImagePreviewData } from "../../../data/bonusUi/Dropzone";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

// This component uses the FilePond library for file uploading with image preview functionality.
const ImagePreview = () => {
  const [files, setFiles] = useState([]);
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={ImagePreviewTitle} span={ImagePreviewData} />
        <CardBody>
          <FilePond files={files} allowReorder={true} allowMultiple={true} maxFiles={1} onupdatefiles={() => setFiles} labelIdle='Drag & Drop your files or <span class="filepond--label-action text-danger text-decoration-none">Browse</span>' />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ImagePreview;
